import { createReducer } from '@reduxjs/toolkit';
import { persistReducer, purgeStoredState } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createTableStateReducers } from '@/store/tableState.reducer';
import t from '@/store/types';

export const defaultTableQuery = {
  filterRoles: [],
  pageIndex: 0,
  pageSize: 20,
};

const initialState = {
  tableState: defaultTableQuery,
};

const STORAGE_KEY = 'leyona:cashflow_accounts';

const CONFIG = {
  key: STORAGE_KEY,
  version: 1,
  whitelist: [],
  storage,
  migrate: (state: any) => {
    // Clear old state that might have incomplete pagination
    if (
      state &&
      !state.tableState?.pageIndex &&
      state.tableState?.pageIndex !== 0
    ) {
      return Promise.resolve(initialState);
    }
    return Promise.resolve(state);
  },
};

const reducerInstance = createReducer(initialState, (builder) => {
  Object.entries(
    createTableStateReducers('CASHFLOW_ACCOUNTS', defaultTableQuery),
  ).forEach(([actionType, reducer]) => {
    builder.addCase(actionType, reducer);
  });

  builder.addCase(t.RESET, () => {
    purgeStoredState(CONFIG);
  });
});

export default persistReducer(CONFIG, reducerInstance);
